<div class="w-full">
  <div class="grid grid-nogutter gap-1 align-items-start">
    <div class="col">
      <crm-editor
        #editor
        [(value)]="value"
        styleClass="w-full"
        (valueChange)="valueChange.emit($event)"
        [height]="height"></crm-editor>
    </div>

    <div>
      <crm-button
        type="button"
        label="{x}"
        styleClass="p-button-success frm-form-control-addon-btn"
        (onClick)="op.toggle($event)"></crm-button>
    </div>
  </div>
</div>

<p-overlayPanel
  #op
  [style]="{ width: '200px' }"
  styleClass="dropdown-overlay-panel">
  <ng-template pTemplate="">
    <p-listbox
      [options]="templateOptions"
      (onChange)="onTemplateOptionSelect($event.value); op.hide()"
      [listStyle]="{ 'max-height': '250px' }"
      listStyleClass="compact-list">
      <ng-template
        let-option
        pTemplate="item">
        {{ option }}
      </ng-template>
    </p-listbox>
  </ng-template>
</p-overlayPanel>
